/**
 * InvestigationTracker — records Archive navigation into Investigation
 * Memory and restores scroll after "Return to Previous Investigation".
 * Mounted once inside the Router. Renders nothing.
 */
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import * as memory from "./investigationMemory";

export const InvestigationTracker = () => {
  const location = useLocation();
  const prevRef = useRef(null);

  useEffect(() => {
    let raf = 0;
    const onScroll = () => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => memory.reportScroll(window.scrollY));
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  useEffect(() => {
    const url = location.pathname + location.search;
    const prev = prevRef.current;
    const wasBack = memory.consumeBackFlag();
    const wasResume = memory.consumeResumeFlag();

    if (prev === null) {
      memory.beginPage(url, { firstMount: true });
    } else if (prev !== url) {
      const prevPath = prev.split("?")[0];
      const samePage = prevPath === location.pathname; // query-only change (filters)
      if (!wasBack && !samePage && memory.isArchivePath(prevPath)) {
        memory.pushEntry(prev);
      }
      memory.beginPage(url, { samePage, wasBack: wasBack || wasResume });
    }
    prevRef.current = url;

    if (wasBack || wasResume) {
      const pr = memory.getPendingRestore();
      if (pr && pr.url.split("?")[0] === location.pathname && (pr.scroll || 0) > 0) {
        memory.restoreScroll(pr.scroll);
      }
    }
  }, [location.pathname, location.search]);

  return null;
};
